import { render, staticRenderFns } from "./TelegramUserLink.vue?vue&type=template&id=75910dd4&"
import script from "./TelegramUserLink.vue?vue&type=script&lang=js&"
export * from "./TelegramUserLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports